import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Deal } from 'app/models/dto/deal.model';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
  selector: 'app-deal-owner',
  templateUrl: './deal-owner.component.html',
  styleUrls: ['./deal-owner.component.scss']
})
export class DealOwnerComponent implements OnChanges {

  @Output() updateOwner = new EventEmitter();
  @Output() loadOwner = new EventEmitter();
  @Input() dealOwnerOptions: LenderUser[];
  @Input() ownerId: number;
  @Input() deal: Deal;
  @Input() canManageDeals: boolean;
  @Input() loading: boolean;
  @Input() readOnly: boolean = false;

  editDealOwnerForm = new UntypedFormGroup({});
  fields: FormlyFieldConfig[] = [];
  model = {};
  editing = false;

  constructor() { }

  openDialog() {
    this.editing = true;
    this.loadOwner.emit();
  }

  ngOnChanges(): void {
    this.model = { dealOwner: this.deal.lenderUserId };
    this.fields = [
      {
        key: 'dealOwner',
        type: 'select',
        templateOptions: {
          label: 'Deal Owner',
          required: true,
          options: this.dealOwnerOptions,
          change: (field, $event) => {
            this.updateOwner.emit($event.value);
            this.editing = false;
          }
        }
      }
    ];
  }
}
